import { Pipe, PipeTransform } from '@angular/core';
/**
 * transform phoneNumber as Telephone format
 */
@Pipe({
  name: 'telephone'
})
export class TelephonePipe implements PipeTransform {
  /**
   * transform value as telephone format
   * @param value value to be converted
   */
  transform(value: string): string {
    if (!value) {
      return '';
    }

    value = value
      .toString()
      .trim()
      .replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return value;
    }

    let country;
    let city;
    let telephoneNumber: string;

    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        telephoneNumber = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        telephoneNumber = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        telephoneNumber = value.slice(5);
        break;

      default:
        return value;
    }

    if (country === 1) {
      country = '';
    }

    telephoneNumber = telephoneNumber.slice(0, 3) + '-' + telephoneNumber.slice(3);

    return (country + '(' + city + ')' + telephoneNumber).trim();
  }
}
